import { render, staticRenderFns } from "./LabelError.vue?vue&type=template&id=73936207&scoped=true"
import script from "./LabelError.vue?vue&type=script&lang=js"
export * from "./LabelError.vue?vue&type=script&lang=js"
import style0 from "./LabelError.vue?vue&type=style&index=0&id=73936207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73936207",
  null
  
)

export default component.exports